import React, { CSSProperties } from 'react';

interface IProps {
	/** Options: s, m, l, xl */
	breakPoint?: string,
	style?: CSSProperties,
	className?: string
}

/** Draws a small line */
function Divider(props: IProps) {
	let className = `divider divider-${props.breakPoint} ${props.className}`;
	if (props.breakPoint) {
		className += ` divider-${props.breakPoint}`;
	}

	return (
		<div
			className={className}
			style={props.style}
		/>
	);
};

export default Divider;